import {
  PayClassificationVariation,
  transformVariationOnGet,
} from './variation'
import { PayClassificationAward, PayClassificationType } from '$constants'
import {
  SelectOption,
  IPayClassificationResponse,
  IPayClassificationTimelineRecordResponse,
} from '$models'

export type {
  IPayClassificationResponse,
  IPayClassificationRequest,
  IPayClassificationTimelineRecordResponse,
  IPayClassificationTimelineRecordRequest,
} from '@loadedhub/core-api-sdk'
export {
  PayClassificationRequest,
  PayClassificationTimelineRecordRequest,
} from '@loadedhub/core-api-sdk'

export interface PayClassificationTimelineRecord
  extends Omit<IPayClassificationTimelineRecordResponse, 'variations'> {
  variations: PayClassificationVariation[]
}

export interface PayClassification
  extends Omit<IPayClassificationResponse, 'variations' | 'timeline'> {
  variations: PayClassificationVariation[]
  timeline: PayClassificationTimelineRecord[]
}

export const PAY_CLASSIFICATION_TIMELINE_MIN_VALID_FROM = '1900-01-01'

const transformPayClassificationTimelineRecordOnGet = (
  record: IPayClassificationTimelineRecordResponse
): PayClassificationTimelineRecord => {
  return {
    ...record,
    variations: (record.variations ?? []).map(transformVariationOnGet),
  }
}

// Function to apply transformations to PayClassification object
export const transformPayClassificationOnGet = (
  payClassification: IPayClassificationResponse
): PayClassification => {
  return {
    ...payClassification,
    datestampDeleted: payClassification.datestampDeleted,
    variations: payClassification.variations!.map(transformVariationOnGet),
    timeline: (payClassification.timeline ?? []).map(
      transformPayClassificationTimelineRecordOnGet
    ),
  }
}

export const newPayClassification: PayClassification = {
  name: '',
  baseHourlyRate: 0,
  type: PayClassificationType.Custom,
  award: PayClassificationAward.Custom,
  variations: [],
  timeline: [],
}

export const getPayClassificationsAsOptions = (
  payClassifications: PayClassification[]
): SelectOption[] =>
  payClassifications.map((payClassification) => {
    return {
      label: payClassification.name,
      value: payClassification.id!,
    }
  })
